const CheckForOnlyNumberInput = (value: string): boolean => {
    const regexForNumberCheck = /^(\s*|\d+)$/;
    return value.match(regexForNumberCheck) !== null;
};

export default CheckForOnlyNumberInput;
